import { api } from "api";
import { useQuery, useMutation } from "@tanstack/react-query";
import { T_Api_Paginated, T_Api_Success_Res } from "./api.types";
import { MediaDto } from "dtos/media.dto";
import { AxiosResponse } from "axios";
import { T_MongoDoc } from "types/_utils.types";

export const mediaService = {
  useGetAllMediaPaginated: ({ page, limit }: { page: number; limit: number }) => {
    return useQuery({
      queryKey: ["media/all", page, limit],
      queryFn: async () => {
        const res = await api.get(`/media/all?page=${page}&limit=${limit}`);
        return res.data?.result as T_Api_Paginated<MediaDto>;
      },
    });
  },
  useGetAllImages: () => {
    return useQuery({
      queryKey: ["media/all/images"],
      queryFn: async () => {
        const res = await api.get(`/media/all/images`);
        return res.data?.result as string[];
      },
    });
  },
  useDeleteByIdOrSlug: () => {
    return useMutation({
      mutationKey: ["delete"],
      mutationFn: async (id: string) => {
        return api.delete(`/media/${id}`, {
          data: { id },
        });
      },
    });
  },

  useEditMedia: () => {
    return useMutation({
      mutationKey: ["edit"],
      mutationFn: async ({ id, ...updateData }: Partial<MediaDto> & { id: string }) => {
        // Make sure to pass updated fields in `updateData`
        return api.patch(`/media/${id}`, updateData); // Sending the updated data in the PATCH request
      },
    });
  },

  useCreateMedia: () => {
    return useMutation({
      mutationKey: ["create"],
      mutationFn: async (formData: FormData) => {
        const res = await api.post("/media", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        return res as AxiosResponse<
          T_Api_Success_Res<({ url: string; caption: string; tags: string; title: string } & T_MongoDoc)[]>
        >;
      },
    });
  },
};
